<cv-current-agent-states-pm
    *ngIf="!config.isCxOne"
    [moduleManager]="moduleManager"
    [moduleKey]="moduleKey"
></cv-current-agent-states-pm>
<cv-current-agent-states-cxone
    *ngIf="config.isCxOne"
    [moduleManager]="moduleManager"
    [moduleKey]="moduleKey"
></cv-current-agent-states-cxone>